export enum AppImages {
    DefaultBackground = "/img/app/DefaultBackground.png",
    DefaultLogo = "/img/app/DefaultLogo.png",

    DefaultDocumentThumbnail = "/img/app/EmptyImage-Document.png",
    DefaultGroupThumbnail = "/img/app/EmptyImage-Group.png",
    DefaultPublicationThumbnail = "/img/app/EmptyImage-Publication.png",
    DefaultUserThumbnail = "/img/app/EmptyImage-User.png",
    DefaultBadgeThumbnail = "/img/app/EmptyImage-Badge.png",
    DefaultInstitutionalThumbnail = "/img/app/EmptyImage-Institutional.png",
    DefaultTopic = "/img/app/EmptyImage-Topic.png",

    PublicationTypeCourseThumbnail = "/img/app/PublicationType-Course.png",
    PublicationTypeListThumbnail = "/img/app/PublicationType-List.png",
    PublicationTypePostThumbnail = "/img/app/PublicationType-Post.png",
    PublicationTypeQuestionThumbnail = "/img/app/PublicationType-Question.png",
    PublicationTypeAnswerThumbnail = "/img/app/PublicationType-Answer.png",
    PublicationTypePollThumbnail = "/img/app/PublicationType-Poll.png",

    NoThumbnailDefined = "/img/app/EmptyImage.png",
    TakePicture = "/img/app/TakePicture.png",
    TakeDocument = "/img/app/TakeDocument.png",
    TakeVideo = "/img/app/TakeVideo.png",
    TakeUpload = "/img/app/TakeUpload.png",

    PlayVideo = "/img/app/PlayVideo.png",
    VideoEncoding = "/img/app/VideoEncoding.png",
    VideoPlayerThumbnail = "/img/app/EmptyImage-VideoPlayer.png",
    VideoProcessing = "/img/app/VideoProcessing.png",

    SystemUserThumbnail = "/img/app/EmptyImage-SystemUser.png",

    TheGenieRight = "/img/app/TheGenieRight.png",
    TheGenieLeft = "/img/app/TheGenieLeft.png",
}
